"use client";

import { useEffect } from "react";

import { env } from "@/common/env/client.mjs";
import { captureException } from "@/common/helpers/capture-exception";

import { sendErrorReport } from "../helpers/send-error-report";

export type EmitErrorReportProps = {
  name: string;
  error: string;
  priority?: "low" | "medium" | "high";
};

const isProduction = env.NEXT_PUBLIC_APP_ENV === "prod";

export function EmitErrorReport({ name, error, priority }: EmitErrorReportProps) {
  useEffect(() => {
    (async () => {
      if (!isProduction) {
        console.log(name);

        console.error(error);
      }

      await sendErrorReport({
        name,
        pathname: window.location.pathname,
        message: error,
        priority,
      });
    })().catch(captureException);
  }, [error, name, priority]);

  return null;
}
